export default "__VITE_ASSET__f657fef0__"